
import { useEffect } from "react";
import { usePixelState } from "./usePixelState";

export function usePixelLifecycle(pixelState: ReturnType<typeof usePixelState>) {
  const {
    pixelId, 
    isSubmitting,
    pixelCreatedRef,
    stateTransitionRef,
    setInstallationState
  } = pixelState;

  // When pixel ID is set, we're in installation phase
  useEffect(() => {
    if (pixelId) {
      // Use setTimeout to ensure state updates happen in the correct order
      setTimeout(() => {
        setInstallationState(true);
        pixelCreatedRef.current = true;
        
        stateTransitionRef.current = {
          isSettingPixelId: false,
          lastOperation: "entered_installation_phase",
          timestamp: Date.now()
        };
      }, 0);
    } else {
      if (!isSubmitting) {
        setInstallationState(false);
      }
    }
  }, [pixelId, isSubmitting]);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (pixelState.timeoutRef.current) {
        clearTimeout(pixelState.timeoutRef.current);
      }
    };
  }, []);

  return {
    ...pixelState
  };
}
